const rootAppKey = "isRootApp";
export const getParentWindow = (currentWindow) => {
    const isRoot = currentWindow[rootAppKey];
    if (isRoot) {
        return currentWindow;
    }
    return window.parent;
};
